import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

// Global client tuned for "instant screens": show cached data immediately,
// refresh quietly in the background, keep cache across reloads.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 min: treat data as fresh -> no refetch on navigation
      gcTime: 24 * 60 * 60 * 1000, // keep in cache 24h
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
      networkMode: "offlineFirst",
      // Stale-While-Revalidate: keep showing the previous key's data while the
      // new key loads -> filter/tab switches never flash a loader.
      placeholderData: (prev) => prev,
    },
  },
});

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "nitaq-rq-cache",
  throttleTime: 1000,
});

// Small helper to build query fns from our api() client.
export function apiQueryFn(path) {
  return async () => {
    const { api } = await import("./api");
    return api(path);
  };
}
